<template>
    <div class="timer_block instapaper_ignore">
        <div class="countdown_title-nest">
            <p class="countdown_title" v-html="formattedTitle"></p>
        </div>
        <div class="countdown">
            <div class="countdown__tile">
                <div class="countdown__digit">
                    <span id="days">{{ timer.days.digit }}</span>
                </div>
                <span class="countdown__title">{{ timer.days.title }}</span>
            </div>
            <div class="countdown__tile">
                <div class="countdown__digit">
                    <span>{{ timer.hours.digit }}</span>
                </div>
                <span class="countdown__title">{{ timer.hours.title }}</span>
            </div>
            <div class="countdown__tile">
                <div class="countdown__digit">
                    <span>{{ timer.minutes.digit }}</span>
                </div>
                <span class="countdown__title">{{ timer.minutes.title }}</span>
            </div>
            <div class="countdown__tile">
                <div class="countdown__digit">
                    <span>{{ timer.seconds.digit }}</span>
                </div>
                <span class="countdown__title">{{ timer.seconds.title }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { setTimerMixin } from '../mixins/setTimerMixin';

export default {
    mixins: [setTimerMixin],
    props: {
        title: {},
        timerEndtime: {},
    },
    computed: {
        formattedTitle() {
            return this.replacePlaceholderBasedOnTimer(this.title, this.$t('sales.in'), this.$t('sales.tonight'));
        },
    },
};
</script>
